import { useIntl } from 'react-intl';

import { Button } from '$HVUI';

//because this is the language we're switching *to*, it's the opposite of locale
export const localeOptions = {
    'en-US': { code: 'es', text: 'Ver en español' },
    es: { code: 'en-US', text: 'View in English' }
};

const LocalePicker = ({ updateIntl }) => {
    const intl = useIntl();

    // If locale is unsupported (not en/es), default to en-US (show es button)
    const localeInfo = localeOptions[intl.locale] || localeOptions['en-US'];
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '1em'
            }}
        >
            <Button
                id="locale-picker-button"
                level="secondary"
                size="narrow"
                name="change-locale"
                text={localeInfo.text}
                onClick={() => updateIntl(localeInfo.code)}
                type="button"
            />
        </div>
    );
};

export default LocalePicker;
